<template>
  <roles-table></roles-table>
</template>

<script>
import RolesTable from '@/components/app/roles/RolesTable'

export default {
  name: "Roles",
  components: {
    RolesTable
  }
}
</script>

<style scoped>

</style>